module.exports = __webpack_public_path__ + "img/wx-mp.19e4e35f.png";